import { SellingMode, type ScheduleTime } from '@src/core/buyerApiClient';

export function scheduleFieldsForSellingMode(
  sellingMode: SellingMode | undefined,
  date: string | undefined,
  time: ScheduleTime | undefined,
) {
  switch (sellingMode) {
    case SellingMode.WithDateAndTime:
      return { date, time };
    case SellingMode.WithDateOnly:
      return { date, time: undefined };
    case SellingMode.WithoutDate:
    default:
      return { date: undefined, time: undefined };
  }
}
